{
  "PAYMENTS": "https://payments-stg.iesdev.com",
  "AUTH": "https://auth-stg.iesdev.com",
  "AUTH_GRAPHQL": "https://auth-stg.iesdev.com/graphql",
  "AUTH_WS_URL": "wss://auth-stg.iesdev.com",
  "KRYPTONITE_API_URL": "https://kryptonite-stg.iesdev.com"
}
